import { render, staticRenderFns } from "./VerticalNavMenuItem.vue?vue&type=template&id=b69da354"
import script from "./VerticalNavMenuItem.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports